const SHIPPER_SHIPMENTS_VIEWED = 'shipper_shipments_viewed';
const SA_ORDERS_PAGINATION_REQUESTED = 'SA_orders_pagination_requested';
const SA_CHOSEN_ORDER_TYPE = 'SA_chosen_order_type';
const SA_OPEN_RECURRING_ORDER_CONFIGURATION_MODAL =
  'SA_open_recurring_order_configuration_modal';

const list = {
  shipmentsViewed: ({ type }) => ({
    eventName: SHIPPER_SHIPMENTS_VIEWED,
    eventData: { type },
  }),

  paginationRequested: ({ type }) => ({
    eventName: SA_ORDERS_PAGINATION_REQUESTED,
    eventData: { type },
  }),

  orderTypeChosen: ({ type }) => ({
    eventName: SA_CHOSEN_ORDER_TYPE,
    eventData: { type },
  }),

  recurringOrderConfigurationModalOpened: ({ id }) => ({
    eventName: SA_OPEN_RECURRING_ORDER_CONFIGURATION_MODAL,
    eventData: { id },
  }),
};

const orders = {
  list,
};

export default orders;
